import instance from "../api/instance";
import { logout } from "./sessionActions";
import { queryString, getFilters } from "../../components/utils/functions";
import {
  PENDING_USERS,
  GET_USER_TYPES,
  CLEAR_ALL_USERS,
  CLEAR_USER_BY_CODE,
  CLEAR_PENDING_USERS,
  GET_USER_BY_CODE,
  GET_USER_ALL,
  GET_USER_DEFAULT_MODULES,
  GET_HOLIDAYS_BY_COUNTRY,
  HANDLE_WORKING_HOURS,
} from "../constants/constants";

export const getPendingUsers = (page = 0, size = 10, filters = []) => {
  filters.unshift({ property: "pendingChange", operator: "eq", value: "true" });

  var searchFilters = getFilters(filters);

  var queryFilters = [{ property: "search", value: searchFilters }];
  queryFilters.push({ property: "sort", value: "updateDate,DESC" });

  return (dispatch) => {
    return instance
      .post(`/users`, { page, size, query: queryString(queryFilters) })
      .then((response) => {
        dispatch({
          type: PENDING_USERS,
          users: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          case 500:
            dispatch(logout());
            break;
        }
      });
  };
};

export const getUserByCod = (codUser, institution = "", userType, country) => {
  let getUserUrl =
    institution == ""
      ? `/users/profile/${codUser}`
      : `/users/profile/${codUser}/${institution}/${country}/${userType}`;
  return (dispatch) => {
    return instance
      .get(getUserUrl)
      .then((response) => {
        dispatch({
          type: GET_USER_BY_CODE,
          user: response.data.data,
        });

        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err.response.data.notifications);
        }
      });
  };
};

/*
export const getAll = (filters) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  return (dispatch) => {
    return instance
      .post(`/users`, { query: queryString(queryFilters)})
      .then((response) =>
        dispatch({
          type: GET_USER_ALL,
          users: response.data.data,
        })
      )
      .catch((err) => {
        var statusCode = err.response.status; 
        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err.response.data.notifications);
        }
      });
  };
};
*/
export const getUserTypes = () => {
  return (dispatch) => {
    return instance
      .get(`/users/types`)
      .then((response) =>
        dispatch({
          type: GET_USER_TYPES,
          userTypes: response.data.data,
        })
      )
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getUsersByInstitution = (
  institutionId,
  page = 0,
  size = 10,
  filters = []
) => {
  filters.push({
    property: "user.status",
    operator: "not",
    value: "DELETED",
  });
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  var query = searchFilters !== "" ? `&${queryString(queryFilters)}` : "";
  // var query = "";

  return (dispatch) => {
    return instance
      .get(
        `/users/institution/${institutionId}?page=${page}&size=${size}${query}&sort=updateDate,DESC`
      )
      .then((response) => {
        dispatch({
          type: GET_USER_ALL,
          users: response.data.data,
        });
        return response.data.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getUserDefaultModules = (institutionId, userType = "PRO") => {
  return (dispatch) => {
    return instance
      .get(`/users/provider-modules-permissions/${userType}/${institutionId}`)
      .then((response) => {
        dispatch({
          type: GET_USER_DEFAULT_MODULES,
          modulo: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getUserHolidayByCountry = (countryCode) => {
  return async (dispatch) => {
    try {
      const response = await instance.get(
        `/holidays-by-country/${countryCode}`
      );

      dispatch({
        type: GET_HOLIDAYS_BY_COUNTRY,
        data: response.data.data,
      });
    } catch (err) {
      const statusCode = err.response.status;
      switch (statusCode) {
        case 401: // Deslogueamos porque el token es inválido
          dispatch(logout());
          break;
        case 500: // Deslogueamos porque el token es inválido
          dispatch(logout());
          break;
        default:
          return Promise.reject(err.response.data.notifications);
      }
    }
  };
};

export const workingHoursHandler = (billProcessing) => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_WORKING_HOURS,
      billProcessing: {
        isWithinWorkingHours: billProcessing.isWithinWorkingHours,
        holidayStatusOk: billProcessing.holidayStatusOk
      }
    });
  };
};

export const clearUserByCode = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_USER_BY_CODE,
    });
};

export const clearPendingUsers = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_PENDING_USERS,
    });
};

export const clearUsers = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_ALL_USERS,
    });
};
